export class LangEngine {
    #lang;
    static #map = new Map([
        ['el', 'el'],
        ['en-US', 'en']
    ])

    constructor(props) {
        this.#lang = props;
    }

    static from(props) {
        const langValue = this.#map.get(props);
        if (typeof langValue === 'undefined') {
            throw new Error(`${props} is not valid language code!!`)
        }
        return new LangEngine(langValue);

    }

    get lang() {
        return this.#lang;
    }

}
